import SharedMediaViewer from "../../../shared/mediaViewer/SharedMediaViewer";

const PRESENTATION_VIEWER_TEST_IDS = {
  root: "presentation-lightbox",
  backdrop: "presentation-lightbox-backdrop",
  toolbar: "presentation-lightbox-toolbar",
  canvas: "presentation-lightbox-canvas",
  loading: "presentation-lightbox-loading",
  error: "presentation-lightbox-error",
  image: "presentation-lightbox-image",
  navPrev: "presentation-lightbox-prev",
  navNext: "presentation-lightbox-next",
  preloadPrev: "presentation-lightbox-preload-prev",
  preloadNext: "presentation-lightbox-preload-next",
  counter: "presentation-lightbox-counter",
};

export function mapPresentationMediaToViewerItems(items) {
  if (!Array.isArray(items)) return [];
  return items
    .filter((item) => item && item.url)
    .map((item, index) => ({
      id: `presentation:${item.position}:${item.kind}:${item.url}`,
      src: item.url,
      alt: item.kind === "plan" ? "Планування" : `Фото ${index + 1}`,
      downloadUrl: item.url,
      kind: item.kind || "image",
    }));
}

function PublicPresentationLightbox({
  items,
  activeIndex,
  onClose,
  onIndexChange,
  restoreFocusRef = null,
}) {
  const mapped = mapPresentationMediaToViewerItems(items);
  const open = mapped.length > 0 && activeIndex != null && activeIndex >= 0;
  if (!open) return null;

  return (
    <SharedMediaViewer
      items={mapped}
      activeIndex={activeIndex}
      onClose={onClose}
      onIndexChange={onIndexChange}
      allowDownload
      restoreFocusRef={restoreFocusRef}
      title="Перегляд фото"
      testIds={PRESENTATION_VIEWER_TEST_IDS}
    />
  );
}

export default PublicPresentationLightbox;
